/**
 * Ключи для privide/inject
 */
export const provideKeys = {
  promoGoodsKey: Symbol(),
  goodsKey: Symbol(),
};
